export default __webpack_public_path__ + "static/media/slidenote3.52755b8d.png";